<template>
  <super-admin-layout>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
          <v-card flat>
            <v-card-actions>
              <v-text-field placeholder="Search Companies" prepend-icon="fa-search" v-model="search" type="text"
                clearable clear-icon="fa-times" @click:clear="resetSearch" @keyup="applySearch"
                class="search-box"></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-select :items="status" :clearable="true" placeholder="Status" item-value="id" item-text="name"
                v-on:change="FilterByStatus($event)" class="search-box"></v-select>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" v-if="$globalConfig.APP_NAME == 'partner'">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-select :items="partners" :clearable="true" placeholder="Partner" item-value="id" item-text="name"
                v-on:change="FilterByPartner($event)" class="search-box" :loading="partnerLoading" hide-no-data
                :disabled="partnerLoading" @change="resetSearchTerm" attach >
                  <template  prepend-item>
                            <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                  </template>
                  <template v-slot:prepend-item>
                            <v-list-item>
                                <v-list-item-content style="padding: 12px 0 0 0;">
                                    <v-text-field v-model="searchTerm" label="Search Partner" @input="onSearchInput"
                                        class="search-term" style="margin:0;" />
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
              </v-select>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" v-if="$globalConfig.APP_NAME == 'direct'">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-select :items="leads" :clearable="true" placeholder="Lead From" item-value="id" item-text="name"
                v-on:change="FilterByLead($event)" class="search-box"></v-select>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" v-if="$globalConfig.APP_NAME == 'direct'">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field placeholder="Search by user email" prepend-icon="fa-search" v-model="emailSearch"
                type="text" clearable clear-icon="fa-times" @click:clear="resetEmailSearch"
                @keyup.enter="applyEmailSearch" class="search-box"></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" class="mt-2" v-if="$globalConfig.APP_NAME == 'senso' || $globalConfig.APP_NAME == 'direct'">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-btn class="mr-1" color="primary" @click.prevent="showCreatePanel()" outlined
                style="margin-left: auto;">
                <v-icon class="pr-2">fa-plus</v-icon>Add Company
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="emailSearched">
        <v-col md="12">
          <v-card flat>
            <v-card-title>User Email Results</v-card-title>
            <v-data-table :headers="emailHeaders" :options.sync="emailOptions"
              :server-items-length="emailServerItemsLength" :items="emailUsers" :loading="emailLoading"
              item-key="id">
              <template v-slot:item.first_name="{ item }">
                <span>{{ item.first_name }} {{ item.last_name }}</span>
              </template>
              <template v-slot:item.company="{ item }">
                <span v-if="item.company && item.company.data">{{ item.company.data.company_name }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn v-if="item.company && item.company.data" color="primary" small
                  :to="'/super-admin/company/' + item.company.data.id">Details</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
          <v-data-table :headers="computedHeaders" :options.sync="options" :server-items-length="serverItemsLength"
          v-show="!loading" :items="users" item-key="id">

            <template v-slot:item.improve="{ item }" v-if="$globalConfig.APP_NAME == 'senso'">
              <v-switch :disabled="item.state == 4" @change="
                item.is_improve_content
                  ? addImproveContent(item.id)
                  : removeContent(item.company_id, item.id, 0)
                " v-model="item.is_improve_content" :value="item.is_improve_content"></v-switch>
            </template>

            <template v-slot:item.edify="{ item }" v-if="$globalConfig.APP_NAME == 'senso'">
              <v-switch :disabled="item.state == 4" @change="
                item.is_edify_content
                  ? addEdifyContent(item.id)
                  : removeContent(item.company_id, item.id, 1)
                " v-model="item.is_edify_content" :value="item.is_edify_content"></v-switch>
            </template>

            <!-- Dynamic slots for membership packages -->
            <template v-for ="pckg in membershipPackages" v-slot:[`item.${pckg.id}`]="{ item }">
              <v-switch :key="pckg.id" :disabled="item.state == 4" @change="
                item.membership_package_id.includes(pckg.id)
                  ? addMembershipContent(item.id, item.company_id, pckg.id, pckg.name)
                  : removeContent(item.company_id, item.id, 2, pckg.id, pckg.name)
                " v-model="item.membership_package_id" :value="pckg.id"></v-switch>
            </template>

            <template v-slot:item.id="{ item }" >
              <v-tooltip bottom v-if="$globalConfig.APP_NAME == 'senso'">
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="item.state == 4" :id="item.id" v-on="on" outlined small color="secondary"
                    @click.prevent="showSettingsPanel(item.company_id)">
                    <v-icon small>fa-gear</v-icon>
                  </v-btn>
                </template>
                <span>Settings</span>
              </v-tooltip>
              <v-tooltip bottom v-if="$globalConfig.APP_NAME == 'senso'">
                <template v-slot:activator="{ on }">
                  <v-btn :disabled="item.state == 4" :id="item.id" v-on="on" outlined small color="secondary" class="ml-1"
                    @click.prevent="showEditPanel(item.id)">
                    <v-icon small>fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <span>Edit Company</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.state != 4 && $globalConfig.APP_NAME == 'senso'">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" color="error" class="ml-1" outlined small @click.prevent="
                    updateState(item.company.data.id, 'suspend')
                    ">
                    <v-icon small>fa fa-ban</v-icon>
                  </v-btn>
                </template>
                <span>Suspend Company</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.state == 4 && $globalConfig.APP_NAME == 'senso'">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" color="error" class="ml-1" outlined small
                    @click.prevent="updateState(item.company.data.id, 'active')">
                    <v-icon small>fa fa-undo</v-icon>
                  </v-btn>
                </template>
                <span>Active Company</span>
              </v-tooltip>
              <v-tooltip bottom v-if="(canCreateCompany || canManagerAccessCustomer) && $globalConfig.APP_NAME == 'senso'">
                <template v-slot:activator="{ on }">
                  <v-btn v-if="loginLoading" color="primary" loading></v-btn>
                  <v-btn v-else v-on="on" :disabled="item.state == 4" color="error" class="ml-1" outlined small
                    @click.prevent="processAccessUser(item.id)">
                    <v-icon small>fa-arrow-right</v-icon>
                  </v-btn>
                </template>
                <span>Access as admin</span>
              </v-tooltip>
              
                <v-btn v-if="$globalConfig.APP_NAME !== 'senso'" color="primary" :to="'/super-admin/company/' + item.id">Details</v-btn>
              
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import SuperAdminLayout from '@/layouts/SuperAdmin';
import companyAPI from '@/api/company.js';
import superAdminAPI from '@/api/superadmin.js';
import testAPI from '@/api/test.js';
import CreateCompany from '@/components/partner/companies/Create';
import CreateDirectCompany from '@/components/superadmin/companies/CreateDirectCompany';
import partnerAPI from '@/api/partner.js';
import EditCompany from '@/components/partner/companies/Edit';
import improveAPI from '@/api/superadmin.js';
import SettingsCompany from '@/components/partner/companies/Settings';
import userAPI from '@/api/user.js';

export default {
  name: 'SuperAdminCompanyList',
  components: {
    SuperAdminLayout,
  },
  data() {
    return {
      headers: [
        { text: 'Company', value: 'company_name', sortable: false },
        {
          text: "Banding",
          value: "banding_description.name",
          sortable: false
        },
        {
          text: '# Users',
          value: 'total_members',
          sortable: false,
        },
        {
          text: "# Courses",
          value: "total_courses",
          sortable: false
        },
        {
          text: 'Name',
          value: 'company_owner_name',
          sortable: false,
        },

        {
          text: 'Email',
          value: 'company_owner_email',
          sortable: false,
        },

        {
          text: 'Status',
          value: 'state_description',
          sortable: false,
        },
        {
          text: "Created",
          value: "created_at"
        },
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      email: '',
      password: '',
      id: '',
      companyId: '',
      fullName: '',
      users: [],
      improve: [],
      edify: [],
      importUsers: '',
      userdata: [],
      search: '',
      searchParams: '',
      pagination: {},
      // Newest first. The table previously sent an empty orderBy, so the API
      // returned primary-key order and a newly created company landed on the
      // LAST page, invisible to the admin who had just created it.
      options: { sortBy: ['id'], sortDesc: [true] },
      loading: false,
      loginLoading: false,
      confirmAccess: 'Are you sure you wish to access this user?',
      confirmRemoveContent: 'Are you sure you want to remove all courses?',
      successMessage: 'content successfully activated.',
      removeContentMessage: 'content now deactivated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      confirmUpdateCompanyState: 'Are you sure you wish to update state to ',
      successUpdateStateMessage: 'State has been updated Successfully',
      status: [
        { id: 1, name: 'Free Trial' },
        { id: 2, name: 'Free Trial Expired' },
        { id: 3, name: 'Active Membership' },
        { id: 4, name: 'Suspended Membership' },
        { id: 5, name: 'Free Trial Extended' },
      ],
      partners:[],
      selectedStatus: "",
      selectedPartner:"",
      timer: null,
      membershipPackages: [],
      leads: [],
      selectedLead: "",
      partnerLoading: false,
      searchTerm: "",
      partnersCopy: [],
      emailHeaders: [
        { text: 'Name', value: 'first_name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Company', value: 'company', sortable: false },
        { text: '', value: 'action', sortable: false, align: 'end' },
      ],
      emailSearch: '',
      emailSearchParams: '',
      emailUsers: [],
      emailPagination: {},
      emailOptions: {},
      emailLoading: false,
      emailSearched: false,
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.$globalConfig.APP_NAME == 'senso') {
        headers.splice(4, 0,
          { text: 'Compliance', value: 'improve', sortable: false },
          { text: 'Safeguarding', value: 'edify', sortable: false }
        );
        this.membershipPackages.forEach((membershipPackage, index) => {
          headers.splice(4 + index, 0, { text: membershipPackage.name, value: membershipPackage.id, sortable: false});
        });
      }
      if (this.$globalConfig.APP_NAME == 'partner') {
        headers.splice(1, 0,
        { text: 'Partner', value: 'partner', sortable: false },
        { text: 'Package', value: 'package', sortable: false},
        );
        headers.splice(10, 0,
          { text: 'Renewal', value: 'renewal_at', sortable: false},
          { text: 'Invoiced', value: 'invoice_type', sortable: false},
       )
      }
      if (this.$globalConfig.APP_NAME == 'direct') {
        headers.splice(7, 0,
        { text: 'Lead From', value: 'lead_from', sortable: false },
        { text: 'Renewal', value: 'renewal_at', sortable: false},
        { text: 'Invoiced', value: 'invoice_type', sortable: false},
      );

      }
      return headers;
    },
    serverItemsLength: function () {
      if (this.pagination && this.pagination.total) {
        return this.pagination.total;
      } else {
        return this.users.length;
      }
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    emailServerItemsLength: function () {
      if (this.emailPagination && this.emailPagination.total) {
        return this.emailPagination.total;
      } else {
        return this.emailUsers.length;
      }
    },
    emailParams: function () {
      return this.$gf.getQueryString(this.emailOptions, this.emailServerItemsLength);
    },
    maxUsers: function () {
      return 500;
    },
    userLimit: function () {
      return this.serverItemsLength >= this.maxUsers ? true : false;
    },
    canCreateCompany: function () {
      if (
        this.$store.getters.level == 1 ||
        this.$store.getters.create_customer_permission == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    canManagerAccessCustomer: function () {
      if (this.$store.getters.level == 1) {
        return true;
      } else {
        return false;
      }
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
    this.loadSearch();
    if (this.$globalConfig.APP_NAME == 'senso') {
      this.getMembershipPackages();
    }
    if(this.$globalConfig.APP_NAME == 'direct') { 
      this.getLeadsData();
    }
    if(this.$globalConfig.APP_NAME == 'partner') { 
      this.getPartnersList();
    }
  },
  watch: {
    options: {
      handler() {
        this.getCompanies();
      },
      deep: true,
    },
    emailOptions: {
      handler() {
        if (this.emailSearched) {
          this.getEmailUsers();
        }
      },
      deep: true,
    },
  },
  methods: {
    removeContent(id, userId, contentType, packageId = '', packageName = '') {
      this.$snotify.confirm(this.confirmRemoveContent, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button', action: (toast) => this.removeToast(toast) },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) =>
              this.processRemoveContent(toast, id, userId, contentType, packageId, packageName),
          }
        ],
      });
    },
    removeToast(toast) {
      this.$snotify.remove(toast.id);
      this.getCompanies();
    },
    processRemoveContent(toast, id, userId, contentType, packageId, packageName) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      superAdminAPI
        .removeEdifyImproveContent(id, userId, contentType, packageId)
        .then((resp) => {
          this.getCompanies();
          this.loading = false;
          var successMessage = '';
          if(packageName == ''){
            successMessage = contentType
            ? 'Safeguarding ' + this.removeContentMessage
            : 'Compliance ' + this.removeContentMessage;
          }else{
            successMessage = packageName + ' Package ' + this.removeContentMessage;
          }
          this.$snotify.success(successMessage);
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    seedTests(id) {
      testAPI.seedTests(id).then((resp) => {
        this.loading = false;
      });
    },
    applySearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.options.page = 1;
        if (this.search != null) {
          const searchKey = this.$globalConfig.APP_NAME == 'senso' 
              ? '&search=company.company_name:'
              : '&search=company_name:';
          this.searchParams = searchKey +  this.search;
        } else {
          this.searchParams = '';
        }
        this.getCompanies();
        this.saveSearch();
      }, 1000);
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      this.applySearch();
      this.saveSearch();
    },
    applyEmailSearch() {
      if (this.emailSearch == null || this.emailSearch == '') {
        this.resetEmailSearch();
        return;
      }
      this.emailSearchParams =
        '&search=email:' + encodeURIComponent(this.emailSearch) + '&include=company';
      if (this.emailSearched) {
        this.emailOptions.page = 1;
        this.getEmailUsers();
      } else {
        // The results table mounts and its options watcher fires the first fetch
        this.emailSearched = true;
      }
    },
    resetEmailSearch() {
      this.emailSearch = '';
      this.emailSearchParams = '';
      this.emailUsers = [];
      this.emailPagination = {};
      this.emailSearched = false;
    },
    getEmailUsers() {
      if (this.emailSearchParams == '') {
        return;
      }
      this.emailLoading = true;
      const params = this.emailParams != '' ? this.emailParams : '?page=1&limit=10';
      userAPI
        .getClients(params, this.emailSearchParams)
        .then((resp) => {
          this.emailUsers = resp.data.data;
          this.emailPagination = resp.data.meta.pagination;
          this.emailLoading = false;
        })
        .catch(() => {
          this.emailLoading = false;
          this.$snotify.error(this.errorMessage);
        });
    },
    getCompanies() {
      this.loading = true;

      let updatedQueryString = '';
      if (this.options.sortDesc.length) {
        // Create an instance of URLSearchParams
        const queryString = new URLSearchParams(this.params);
        // Convert the URLSearchParams instance to an object
        const paramsObject = Object.fromEntries(queryString.entries());
        paramsObject.sortedBy = this.options.sortDesc[0] ? 'desc' : 'asc';

        // Update the URLSearchParams with the modified paramsObject
        const updatedParams = new URLSearchParams(paramsObject);

        // Convert the updated URLSearchParams back to a query string
        updatedQueryString = `?${updatedParams.toString()}`;
      } else {
        updatedQueryString = this.params
      }
      if (this.$globalConfig.APP_NAME != 'senso') {
      companyAPI
        .getCompanies(updatedQueryString,this.searchParams, this.selectedStatus, this.selectedLead, this.selectedPartner)
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
      }else{
        companyAPI
        .getCustomers(
          updatedQueryString, this.searchParams + '&include=company&demo=yes',
          this.selectedStatus,this.selectedPartner
        )
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
      }
    },

    showEditPanel(id) {
      this.$showPanel({
        component: EditCompany,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },

    showCreatePanel() {
      // Direct gets its own create form. The partner one posts partner_id/product and
      // carries hardcoded partner-id checks, so it is the wrong shape for Direct.
      if (this.$globalConfig.APP_NAME == 'direct') {
        this.$showPanel({
          component: CreateDirectCompany,
          props: {
            params: this.params,
          },
          openOn: 'right',
        });
        return;
      }
      this.$showPanel({
        component: CreateCompany,
        props: {
          params: this.params,
          id: this.$store.getters.user.id,
        },
        openOn: 'right',
      });
    },
    addImproveContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyImproveContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Compliance ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        })
        .catch((err) => {
          this.getCompanies();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    addEdifyContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Safeguarding ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        })
        .catch((err) => {
          this.getCompanies();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },

    loginToOwner(id) {
      this.$snotify.confirm(this.confirmAccess, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processAccessUser(toast, id),
          }
        ],
      });
    },
    processAccessUser(id) {
      this.loginLoading = true;
      partnerAPI.getOwnersDetail(id).then((resp) => {
        this.userdata = resp.data.data;
        this.email = this.userdata[0].email;
        this.password = this.userdata[0].password;
        this.id = this.userdata[0].id;
        this.autologin();
        //this.loading = false;
      });
    },
    autologin: function () {
      this.$store
        .dispatch('autologin', {
          id: this.id,
        })
        .then(() => {
          localStorage.setItem('todos', this.$store.getters.user.id);
          this.getProfile();
        })
        .catch((err) => {
          this.valid = false;
          this.loginLoading = false;
          this.messages = [];
          let errors = err.response.data.errors;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.errorMessage = errMsg;
            this.$snotify.error(errMsg);
          }
          if (errors) {
            for (let field in errors) {
              this.messages[field] = errors[field];
            }
          }
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 2:
              this.$router.push('/admin/users');
              break;
            default:
              this.$router.push('/courses');
              break;
          }
        })
        .catch((err) => {
          this.loginLoading = false;
        });
    },

    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        //this.params = payload;
        // Jump to the first page before refreshing: with newest-first ordering
        // a company created from page 7 of ~160 would otherwise reload the page
        // the admin happened to be on and appear not to have been created.
        if (this.options) {
          this.options.page = 1;
        }
        this.getCompanies();
      });
      EventBus.$on('USERS_ADDED', (payload) => {
        //this.params = payload;
        this.getCompanies();
      });
      EventBus.$on('closePanel', (payload) => {
        this.getOwners();
      });
    },
    updateState(id, state = '') {
      var confirmUpdateCompanyState =
        this.confirmUpdateCompanyState + state + '?';
      this.$snotify.confirm(confirmUpdateCompanyState, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processUpdateCompanyState(toast, id, state),
          }
        ],
      });
    },
    processUpdateCompanyState(toast, id, state) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      companyAPI.updateCompanyState(id, '', state).then(() => {
        this.$snotify.success(this.successUpdateStateMessage);
        this.getCompanies();
        this.loading = false;
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
      });
    },
    saveSearch() {
      // Save search value to localStorage
      if (this.search && this.search.length > 0) {
        localStorage.setItem('search-company', this.search);
      } else {
        localStorage.removeItem('search-company');
      }
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('search-company');
      if (savedSearch !== null) {
        this.search = savedSearch;
        const searchKey = this.$globalConfig.APP_NAME == 'senso' 
              ? '&search=company.company_name:'
              : '&search=company_name:';
        this.searchParams = searchKey + savedSearch;
      }
    },
    FilterByStatus(status) {
      if (typeof status != 'undefined' && status !== null)
        this.selectedStatus = '&state=' + status;
      else
        this.selectedStatus = '';

      this.getCompanies();
    },
    getMembershipPackages(){
      improveAPI.getMembershipPackages().then(response => {
            this.membershipPackages = response.data.data;
        });
    },
    addMembershipContent(id, companyId, packageId, packageName){
      this.loading = true;
      improveAPI
        .createMembershipContent(this.$store.getters.user.id, id, companyId, packageId)
        .then(() => {
          this.$snotify.success(packageName + ' Package ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.getCompanies();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getLeadsData(){
      improveAPI.getLeadsData().then((response) => {
          this.leads = response.data.data;
        });
    },
    FilterByLead(lead){
      if (typeof lead != 'undefined' && lead !== null)
        this.selectedLead = '&lead_id=' + lead;
      else
        this.selectedLead = '';

      this.getCompanies();
    },
     showSettingsPanel(id) {
      this.$showPanel({
        component: SettingsCompany,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    FilterByPartner(partner) {
      if (typeof partner != 'undefined' && partner !== null)
        this.selectedPartner = '&partnerId=' + partner;
      else
        this.selectedPartner = '';

      this.getCompanies();
    },
    getPartnersList(){
      this.partnerLoading = true;
       partnerAPI
        .getPartnersList()
        .then((response) => {
          this.partners = response.data.data;
          this.partnerLoading = false;
          this.partnersCopy = [...this.partners];
        });
    },
    onSearchInput(){
      // Triggered when user types in the search field
      if (!this.searchTerm) {
        this.partners = this.partnersCopy; // Reset to original if search is empty
      }

      // Filter the array by matching the `name` property
         this.partners = this.partnersCopy.filter((item) =>
           item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
         );
    },
     resetSearchTerm(){
          this.searchTerm = ""; // Clear the search term
          this.partners = this.partnersCopy; // Reset filtered fruits
     },

  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding-top: 6px !important;
  margin-top: 0px !important;
}

</style>
